const baseURL = `portal-event/`;

export const getEventsUrl = () => `portal-event/event/IP_020`;

export const getProfileCandidateURL = (id: string) =>
  `${baseURL}post/IP_020/${id}`;

export const handleVoteURL = `${baseURL}voting/IP_020`;

export const getVoteResultURL = `${baseURL}post/IP_020`;

export const getPostRemainURL = (ignoreTop: number) =>
  `${baseURL}post/IP_020/ignore-top/${ignoreTop}`;

export const getDetailEventsUrl = (id: string) =>
  `portal-event/event/IP_020/${id}`;

export const getProgramsUrl = () => `portal-event/award/IP_020`;

export const getDetailProgramUrl = (id: string) =>
  `portal-event/award/IP_020/${id}`;

export const getVotesUrl = () => `portal-event/post/IP_020`;
